import { useShortIdContext } from '@air/provider-short-id';

import { usePublicShowcaseContext } from '~/providers/PublicShowcaseProvider';
import { usePublicGalleryViewItems } from '~/swr-hooks/gallery/galleryView/usePublicGalleryViewItems';

/**
 * Live `/a` board-drill gallery items. ShortUrl children scoped to the page's collection (or the
 * link root). Edit + Preview supply `useShowcaseEditorBoardGalleryViewItems` on the layout contract.
 */
export const usePublicShowcaseBoardGalleryViewItems = () => {
  const { activePage } = usePublicShowcaseContext();
  const { objectId } = useShortIdContext();

  return usePublicGalleryViewItems({ collectionId: activePage?.pageId ?? objectId });
};
